module.exports = __webpack_public_path__ + "static/img/icon_search @2x.7d976ae0.png";